module.exports = __webpack_public_path__ + "afcf999578deb0a2106ba1c8a82466af.pdf";